/*
 * Candidate Project Certificate Messages
 *
 * This contains all the text for the Candidate Project Certificate component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateProjectCertificate';

export default defineMessages({
  deleteCertificateConfirmMessage: {
    id: `${scope}.deleteCertificateConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete this Certificate?',
  },
});
